import type { ReactNode } from 'react';
import type { Layout } from '../stage';

/** The design-unit stage (1600 × 900, or 900 × 1600 in portrait) scaled uniformly to fit the viewport (spec §2, §12). */
export function Stage({ layout, className, children }: { layout: Layout; className?: string; children: ReactNode }) {
  return (
    <div className="stage-viewport">
      <div className={`stage${layout.portrait ? ' portrait' : ''}${className ? ` ${className}` : ''}`} data-testid="stage"
        style={{ width: layout.width, height: layout.height, transform: `translate(-50%, -50%) scale(${layout.scale})` }}>{children}</div>
    </div>
  );
}
